import {loadStripe} from '@stripe/stripe-js';
import {envAwarePost} from '../util/util'

const initStripe = async ()=>{
	const res = await envAwarePost(
		'api/financials/',
		{action:'fetchStripePublishableKey'}
	)
	if(res.success==='1'){
		return await loadStripe(res.data.key)
	} else {
		if(!window.SHOW_PAYMENT_ALERT){
			window.alert('There was an error setting up the payment system. Please, reload the page.')
			window.SHOW_PAYMENT_ALERT = false
		}
	}
}

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
let stripePromise = initStripe()

/**
 * Since we have connect account transactions on the old stripe account
 * and everything else on the new stripe account we need an option to 
 * use the latest one (ie the MacroActive owned FitSW NZ based stripe)
 **/
const initStripeLatest = async ()=>{
	const res = await envAwarePost(
		'api/financials/',
		{action:'fetchStripePublishableKey',force_new:1}
	)
	if(res.success==='1'){
		return await loadStripe(res.data.key)
	} else {
		if(!window.SHOW_PAYMENT_ALERT){
			window.alert('There was an error setting up the payment system. Please, reload the page.')
			window.SHOW_PAYMENT_ALERT = false
		}
	}
}

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
export const stripePromiseLatest = initStripeLatest()

export default stripePromise